export default __webpack_public_path__ + "static/media/logo.67a79d4e.png";